import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["symbol symbol-fixed", [
      { 'symbol-160px symbol-xl-200px': _ctx.size == 'large' },
      { 'symbol-100px symbol-lg-160px': _ctx.size == 'medium' },
      { 'symbol-50px': _ctx.size == 'small' },
      { [_ctx.customClass]: true },
    ]])
  }, [
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "symbol-label fw-bold text-success",
          style: _normalizeStyle({ 'font-size': (_ctx.size == 'small' ? 1 : _ctx.sizeCalc) + 'em' })
        }, _toDisplayString(_ctx.text), 5))
      : _createCommentVNode("", true),
    (_ctx.img)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.img,
          alt: "image"
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}